
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.414 20.695h8.297c1.617 0 2.422-.82 2.422-2.453v-1.445h1.523c1.617 0 2.422-.82 2.422-2.453V7.008c0-.961-.187-1.57-.773-2.172L13.359.82c-.562-.57-1.21-.773-2.046-.773H7.358C5.75.047 4.938.867 4.938 2.5v1.445H3.413c-1.61 0-2.422.82-2.422 2.453v11.844c0 1.64.813 2.453 2.422 2.453zm10.719-9.547c0-1-.11-1.437-.735-2.078L9.086 4.68c-.594-.602-1.078-.735-1.961-.735h-.93v-1.43c0-.765.422-1.21 1.227-1.21h4.047V5.39c0 .898.445 1.336 1.336 1.336h4.015v7.601c0 .774-.414 1.211-1.226 1.211h-1.461v-4.39zm-1.14-5.554c-.274 0-.391-.117-.391-.39v-3.65l3.968 4.04h-3.578zM3.476 19.437c-.805 0-1.227-.437-1.227-1.21V6.414c0-.773.422-1.21 1.234-1.21h3.47v4.53c0 .985.5 1.47 1.468 1.47h4.453v7.023c0 .773-.414 1.21-1.227 1.21H3.477zm5.085-9.414c-.304 0-.43-.125-.43-.43V5.446l4.5 4.578h-4.07z","fill":"#000"}})])
          )
        }
      }
    